import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { avatar, DefaultProfile } from "../../assets/img";
import itemLogo from "../../assets/img/items/item_1.png";
import { GweiToether } from "../../hooks/Tokenhook";
import { Badge, Button, Modal } from "react-bootstrap";
import { ContractABI } from "../../config/ABIs/ContractABI";
import { useDispatch, useSelector } from "react-redux";
import { ethers } from "ethers";
import { FaHeart, FaRegCirclePlay, FaRegHeart } from "react-icons/fa6";
import { likeNFT, viewNFT } from "../../hooks/NFTHook";
import axios from "axios";

const userId = localStorage.getItem("userId");

const DynamicNFTCard = ({
  NFTLink,
  contractAddress,
  currentOwnerPic,
  currentOwnerName,
  currentOwnerLink,
  mediaUrl,
  assetType,
  title,
  price,
  likes,
  isLiked,
  tokenId,
  isListed,
  button,
  buttonMessage,
  isProfile,
  currentActive,
  isCollection,
  nftId,
  type,
  creator
}) => {
  const handleError = (e) => {
    e.target.src = avatar; // Fallback for profile picture
  };
  const PROVIDER = useSelector((state) => state.valueFromHeader);
  const [hover, setHover] = useState(false);
  const [open, setOpen] = useState(false);
  const [newPrice, setNewPrice] = useState();
  const [isHovered, setIsHovered] = useState(false);
  const [fav, setFav] = useState(isLiked);
  const [likeCount, setLikeCount] = useState(likes);
  const location = useLocation();
  // console.log("location", location.pathname.split('/')[1], location.pathname.split('/')[1] === "nftdetails");

  const route = useNavigate();
  const dispatch = useDispatch();

  const handleMediaError = (e) => {
    if (assetType.split("/")[0] !== "image") {
      // console.log("assetType", assetType.slice("/"));
      e.target.poster = "/default-video.png"; // Fallback for video poster
    } else {
      e.target.src = itemLogo; // Fallback for image
    }
  };
  const closeModal = () => {
    setOpen(false);
  }


  const handleLike = async (e) => {
    try {
      e.stopPropagation();

      if (!userId) {
        toast.dismiss();
        toast.error("Please login first!");
        return;
      }

      const body = { userId: userId };
      toast.dismiss();

      const response = await likeNFT(nftId, body);
      
      if (!response || !response.success) {
        throw new Error(response?.message || 'Failed to update like status');
      }

      if (!fav) {
        setLikeCount(prevCount => Number(prevCount) + 1);
        setFav(true);
        toast.success("Liked Successfully!");
      } else {
        setLikeCount(prevCount => Number(prevCount) - 1);
        setFav(false);
        toast.success("Disliked Successfully!");
      }

    } catch (error) {
      console.error("Error handling like/dislike:", error);
      toast.error(error.message || "Failed to update. Please try again.");
    }
  };



  const RedeployOnMarketplace = async () => {
    // showLoader();
    try {
      const wallet = await PROVIDER.getSigner();
      const contracts = new ethers.Contract(
        contractAddress,
        ContractABI,
        wallet
      );

      const AddedPrice = ethers.parseEther(newPrice);

      const test = await contracts.addNftToMarket(
        tokenId,
        AddedPrice
      );

      const receipt = await test.wait();
      if (receipt) {
        toast.success("Transaction successful. Created NFT successfully !!!")
        setTimeout(() => {
          route('/marketplace');
          // hideLoader()
        }, 2000);
      }
    } catch (error) {
      console.error("Error calling function:", error);
    }
  };

  const redirect = () => {
    incrementView()
    if (location.pathname.split('/')[1] === "nftdetails") {
      localStorage.setItem('stateManage', true)
      route(NFTLink)
    }
    else {
      route(NFTLink)
    }
  }
  const incrementView = async () => {
    try {
      const IP = await axios.get("https://ipinfo.io/json?token=50e340973fcdd8");
     const data= await viewNFT({ipAddress:IP.data.ip}, nftId)
     console.log("Data add BViiew", data);
     
    } catch (error) {
      console.error("Error updating view count:", error);
    }
  };
  console.log("Dynamic Card", creator);

  return (
    <>
      <div
        className={` ${hover ? "hovered" : ""}`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}

      >
        {/* <Link to={NFTLink}> */}
        <div>
          <div className="card__item four">
            <div className="card_body space-y-10">
              {/* Creator Section */}
              <div className="creators space-x-10"
               
              >
                {isProfile &&
                  <div className="avatars space-x-3">
                    <Link to={currentOwnerLink} className="d-flex align-items-center">
                      <img
                        src={currentOwnerPic !== null ? currentOwnerPic : avatar}
                        alt="Creator"
                        className="avatar avatar-sm"
                        onError={handleError}
                      />
                      <p className="avatars_name txt_xs mx-2">{currentOwnerName || "Unknown"}</p>
                    </Link>
                  </div>
                }
                <div>
                  {currentActive === true &&
                    <Badge pill bg="success">Active</Badge>
                  }
                  {
                  type === "Lazy Mint" &&
                    <Badge pill bg="danger" className="ml-2">Lazy Minted</Badge>
                  }{
                    isListed === false &&
                  <Badge pill bg="danger" className="ml-2">Not Listed</Badge>

                  }
                </div>
              </div>

              <div className="card_head"  onClick={() => redirect()}>
                <div  onClick={() => redirect()}>
                {assetType.split("/")[0] !== "image" ? (
                  <div
                    className="video-wrapper"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    style={{ width: '100%', height: '300px', position: 'relative', overflow: 'hidden', borderRadius: '18px' }}
                  >
                    <video
                      style={{ 
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '18px',
                        position: 'absolute',
                        top: '0',
                        left: '0'
                      }}
                      muted
                      loop
                      playsInline
                      className={`video ${isHovered ? "playing" : ""}`}
                      onMouseEnter={(e) => e.target.play()}
                      onMouseLeave={(e) => e.target.pause()}
                    >
                      <source src={mediaUrl} type={assetType} />
                      Your browser does not support the video tag.
                    </video>
                    {!isHovered && (
                      <div className="pause-overlay" style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: '2rem',
                        color: '#fff',
                        zIndex: 2
                      }}>
                        <FaRegCirclePlay />
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={{ width: '100%', height: '300px', position: 'relative', overflow: 'hidden', borderRadius: '18px' }}>
                    <img
                      src={mediaUrl}
                      alt={`Preview ${assetType}`}
                      style={{ 
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '18px'
                      }}
                    />
                  </div>
                )}
                </div>

                <div className="likes space-x-3">
                  <div
                    className={`like-icon ${fav ? "liked" : ""}`}

                    style={{ cursor: "pointer" }}
                  >
                    {fav ? (
                      <span style={{ color: "red" }} onClick={handleLike}>{likeCount} ❤️</span>
                    ) : (
                      <span style={{ color: "red" }} onClick={handleLike}> <span> {Number(likeCount) !== 0 && likeCount } </span>♡</span>
                    )}
                  </div>
                </div>
              </div>


              {/* Footer Section */}
              <div className="card_footer d-block space-y-10"
                onClick={() => redirect()}
              >
                <div
                  className="d-flex align-items-center space-x-10 justify-content-between"
                >
                  <div className="d-flex align-items-center space-x-5">
                    <h6 className="card_title">
                      <div
                        className="color_black"
                        style={{ textTransform: "capitalize" }}
                      >
                        {hover ? title : title?.slice(0, 15) + (title?.length > 15 ? "..." : "")}
                      </div>
                    </h6>
                  </div>
                  {isCollection &&
                    <>
                      {button ?
                        <button className="btn btn-sm btn-primary">
                          {buttonMessage}
                        </button>
                        :
                        <div className="txt_sm">
                          Price:{" "}
                          <span className="color_green txt_sm">

                            {price} ETH
                          </span>
                        </div>
                      }
                    </>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </Link> */}
      </div>
      <Modal
        show={open}
        size="lg"
        onHide={closeModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Re deploy NFTs on Marketplace
          </Modal.Title>

        </Modal.Header>
        <Modal.Body>
          <h4> Add Price for Redeploy NFT</h4>
          <p>
            We can upgrade our profile picture as a first NFTs for our trade and understanding about NFTs and marketplace.
          </p>
          <div className="space-y-10">
            <span className="nameInput">Price</span>
            <input
              type="text"
              className="form-control"
              placeholder="Price"
              name='title'
              onChange={(e) => setNewPrice(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => closeModal()}>Cancal</Button>
          <Button onClick={() => RedeployOnMarketplace()}>Add to Market </Button>
        </Modal.Footer>
      </Modal>

    </>

  );
};

// Prop Validation
DynamicNFTCard.propTypes = {
  NFTLink: PropTypes.string,
  contractAddress: PropTypes.string,
  currentOwnerPic: PropTypes.string,
  currentOwnerName: PropTypes.string,
  currentOwnerLink: PropTypes.string,
  creatorOwnerPic: PropTypes.string,
  creatorOwnerName: PropTypes.string,
  creatorOwnerLink: PropTypes.string,
  mediaUrl: PropTypes.string,
  assetType: PropTypes.string,
  isVideo: PropTypes.bool,
  title: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  likes: PropTypes.number,
  isLiked: PropTypes.bool,
  isListed: PropTypes.bool,
  button: PropTypes.bool,
  buttonMessage: PropTypes.string,
  isProfile: PropTypes.bool,
  isCollection: PropTypes.bool,
  nftId: PropTypes.string
};

DynamicNFTCard.defaultProps = {
  NFTLink: "nftType/contactAddress/tokenId(_id)",
  contractAddress: "contractAddress",
  currentOwnerPic: { DefaultProfile },
  currentOwnerName: "Unknown",
  currentOwnerLink: `${`/otherProfile/creatorAddress`}`,
  creatorOwnerPic: { DefaultProfile },
  creatorOwnerName: "Unknown",
  creatorOwnerLink: `${`/otherProfile/creatorAddress`}`,
  mediaUrl: itemLogo,
  assetType: "image",
  isVideo: false,
  title: "title",
  price: null,
  likes: 0,
  isLiked: false,
  isListed: true,
  button: false,
  buttonMessage: "Button",
  isProfile: true,
  isCollection: true,
  nftId: ""
};

export default DynamicNFTCard;
























